export default __webpack_public_path__ + "static/media/alur-3.b04302e6.png";